import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { PropertyBrowserNodeOUT } from "api-client";
import TooltipComponent from "components/Tooltip";
import { useNodeLabel } from "./PropertyBrowserNodeRow";

const BREADCRUMB_MAX_SEGMENTS = 2;

const PropertyBrowserSearchResult = observer(
  function PropertyBrowserSearchResult({
    node,
    onSelect,
    rootGroupId,
  }: {
    node: PropertyBrowserNodeOUT;
    onSelect: (node: PropertyBrowserNodeOUT) => void;
    rootGroupId?: string;
  }) {
    const label = useNodeLabel(node);
    const { i18n } = useTranslation();
    const isEng = i18n.language === "en";

    const crumbs = node.breadcrumb ?? [];
    const startIndex = rootGroupId
      ? crumbs.findIndex((b) => b.node_id === rootGroupId) + 1
      : 0;
    const segments = crumbs
      .slice(startIndex)
      .map((b) => (isEng ? b.name : b.name_de || b.name));

    const fullBreadcrumb = segments.join(" › ");
    const needsTruncation = segments.length > BREADCRUMB_MAX_SEGMENTS;
    const displayBreadcrumb = needsTruncation
      ? `… › ${segments.slice(-BREADCRUMB_MAX_SEGMENTS).join(" › ")}`
      : fullBreadcrumb;

    return (
      <div
        className="px-4 py-2 cursor-pointer hover:bg-indigo-50 hover:text-indigo-700"
        onClick={() => onSelect(node)}
      >
        <div className="text-sm font-medium truncate">{label}</div>
        {displayBreadcrumb &&
          (needsTruncation ? (
            <TooltipComponent
              content={`${fullBreadcrumb} › ${label}`}
              noFlex
              noIcon
            >
              <div className="text-xs text-gray-400">{displayBreadcrumb}</div>
            </TooltipComponent>
          ) : (
            <div className="text-xs text-gray-400">{displayBreadcrumb}</div>
          ))}
      </div>
    );
  }
);

export default PropertyBrowserSearchResult;
